//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'

export default {
  name: "followOrderDetailAll",
  components: {
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/pages/report/detailAll.vue